import { db } from "../../scripts/firebase";
import {
  arrayRemove,
  arrayUnion,
  deleteDoc,
  doc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { capture } from "../analytics/capture";

export const favoriteProperty = async (
  user,
  claims,
  favorite,
  setFavorite,
  property,
  dataSource
) => {
  let propertyID =
    dataSource === "FIRESTORE" ? property.propertyID : property.objectID;
  if (user && claims.user) {
    if (!favorite) {
      setFavorite(true);

      const propertyRef = doc(db, "Properties", propertyID);

      const docRef = await setDoc(
        doc(db, "Users", user.uid, "SavedProperties", propertyID),
        {
          propertyID: propertyID,
          savedTime: serverTimestamp(),
        }
      ).catch(() => {
        setFavorite(false);
      });
      const propRef = await setDoc(
        doc(db, "Properties", propertyID, "SavedBy", user.uid),
        {
          savedTime: serverTimestamp(),
        }
      ).catch(() => {
        setFavorite(false);
      });
      await updateDoc(propertyRef, {
        savedBy: arrayUnion(user.uid),
      });
      capture({
        category: "browse",
        event: "favorite_add",
        properties: property,
      });
    } else {
      setFavorite(false);
      const propertyRef = doc(db, "Properties", propertyID);
      await deleteDoc(
        doc(db, "Users", user.uid, "SavedProperties", propertyID)
      ).catch(() => {
        setFavorite(true);
      });
      await deleteDoc(
        doc(db, "Properties", propertyID, "SavedBy", user.uid)
      ).catch(() => {
        setFavorite(true);
      });

      await updateDoc(propertyRef, {
        savedBy: arrayRemove(user.uid),
      });
      capture({
        category: "browse",
        event: "favorite_remove",
        properties: property,
      });
    }
  }
};
